<template>
  <div class='EnbStart'>
    <div class="cont">
      <div class="icon-rocket">
        <rocket-icon color="#FFFFFF"/>
      </div>
      <div class="text">DECOLE SEU NOGÓCIO NA INTERNET.</div>
      <component
      :is="currentView"
      @updateProp="data => payload[data.key] = data.value"
      @changeView="view => setCurrentView(view)"
      :payload="payload"
      />
      <div class="fundo"></div>
    </div>
  </div>
</template>

<script>
import RocketIcon from '@/components/EnbPainel/Icons/RocketIcon'
import StepOne from '@/components/init/StepOne'
import StepTwo from '@/components/init/StepTwo'
import StepThree from '@/components/init/StepThree'
export default {
  name: 'EnbStart',
  components: { RocketIcon, StepOne, StepTwo, StepThree },
  data () {
    return {
      currentView: 'StepTwo',
      payload: {
        nome_empresa: "",
        subdominio: "",
        modelo: "",
        nome: "",
        sobrenome: "",
        usuario: "",
        email: "",
        senha: "",
        csenha: "",
        tipo: "a",
        telefone: '',
        cep: '',
        rua: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        uf: '',
        logo: '',
        favicon: '',
        banner: '',
        fonte: '',
        corPadrao: '#1fdae0',
        corFundo: '#FFFFFF',
        corCard: '#FFFFFF',
        corFonte: '#000000',
        corNome: '#000000',
        corCateg: '#FFFFFF'
      }
    }
  },
  methods: {
    setCurrentView (view) {
      this.currentView = view
    }
  }
}
</script>

<style scoped>
.EnbStart {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background-color: #0e1e2b;
  overflow: auto;
  /* background-image: url('../assets/background.jpeg'); */
}

.cont {
  width: 50%;
  height: 100%;
}

.icon-rocket {
  padding-top: 5%;
}

.text {
  font-family: Poppins;
  width: 100%;
  padding-bottom: 5%;
  font-weight: 600;
  font-size: 35px;
  line-height: 36px;
  margin: auto;
  color: #FFFFFF;
  text-shadow: 
    -1px -1px 0 black, /* Contorno superior esquerdo */
    1px -1px 0 black,  /* Contorno superior direito */
    -1px 1px 0 black,  /* Contorno inferior esquerdo */
    1px 1px 0 black;
}

.cont-form {
  width: 96%;
  border-radius: 8px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 3px 0.05px #B3B3B3;
  padding: 5%;
}

.fundo {
  width: 100%;
  height: 100px;
}

.cont-sub {
  display: flex;
  align-items: end;
  padding: 1.5%;
}

.cont-dominio {
  display: flex;
  padding: 2%;
  padding-left: 0;
  margin-left: 1%;
}

@media (max-width: 500px) {
  .cont {
    width: 90%;
  }
  .text {
    /* text-align: justify; */
    font-size: 30px;
  }
}
</style>
